import React, { useEffect, useRef, useState } from "react";
import ReactToPrint from "react-to-print";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  Button,
  Icon
} from "../../components/Component";
import { getToken } from "../../helper/auth";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";

import * as moment from "moment";
import { NumericFormat } from "react-number-format";
import { useHistory, useLocation } from "react-router-dom";
import { useRecoilState, } from 'recoil';
import Table from "../../components/react-table/Table";
import { GET } from "../../helper/api";
import { popupCustomerFlowAtom, popupExchangeBetweenBankAccountAtom, popupTransactionHistoryAtom } from '../../state';


const MonthlyReport = () => {
  const printRef = useRef();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [popupTransactionHistory] = useRecoilState(popupTransactionHistoryAtom);
  const [popupCustomerFlow] = useRecoilState(popupCustomerFlowAtom);
  const [popupExchangeBetweenBankAccount] = useRecoilState(popupExchangeBetweenBankAccountAtom);

  const history = useHistory();
  const clearPagi = useRef();
  const [data, setData] = useState([]);

  const [loading, setLoading] = useState(false);
  const [smOption, setSmOption] = useState(false);
  const [summary, setSummary] = useState({});

  const [filter, setFilter] = useState({
    monthYear: searchParams.get('monthYear') || moment().format('YYYY-MM'),
  });

  const colTable = [

    {
      Header: "Ngày",
      accessor: (item) => moment(item.date).format("DD/MM/YYYY"),
    },

    {
      Header: "Tiền thu trong ngày(đ)",
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.inAmount}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />
    },
    {
      Header: "Tiền chi trong ngày(đ)",
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.outAmount}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />
    },
    {
      Header: "Luỹ tiến(đ)",
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.lessAmount}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />,
    },
  ];

  const exportExcel = () => {
    const params = new URLSearchParams({
      ...(filter.monthYear ? { monthYear: filter.monthYear } : {}),
      token: getToken(),
    })
    const url = `${process.env.REACT_APP_API_URL}/api/v1/report/monthly-report-excel?${params.toString()}`;
    window.open(url, '_blank')
  };

  useEffect(() => {
    const newParams = new URLSearchParams({
      ...(filter.monthYear ? { monthYear: filter.monthYear } : {}),

    });
    history.replace({
      pathname: location.pathname,
      search: newParams.toString(),
    })
    setLoading(true);
    setData([]);
    clearTimeout(clearPagi.current);
    clearPagi.current = setTimeout(() => {
      let params = {
        ...(filter.monthYear ? { monthYear: filter.monthYear } : {}),
      };

      GET(`/report/monthly-report`, params, true)
        .then(({ data }) => {
          setData([...data?.rows]);
          setSummary({
            ...data.summary,
          });
        })
        .finally(() => {
          setLoading(false);
        });
    }, 400);
  }, [filter, popupTransactionHistory.updatedAt, popupCustomerFlow.updatedAt, popupExchangeBetweenBankAccount.updatedAt]);

  return (
    <React.Fragment>
      <Head title="Kiểm kê giao dịch"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li>
                      <div
                        className="form-control-wrap mw-150px"
                      >
                        <input
                          type="month"
                          className="form-control  border-primary"
                          value={filter.monthYear}
                          onChange={(e) =>
                            setFilter({
                              ...filter,
                              monthYear: e.target.value,
                            })
                          }
                        />
                      </div>

                    </li>
                  </ul>
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">


                    <li>
                      <div className="form-control-wrap mw-150px">
                        <ReactToPrint
                          trigger={() => <Button className={'btn btn-secondary'}>In</Button>}
                          content={() => printRef.current}
                        />
                        <Button onClick={exportExcel} className="btn btn-secondary ml-3">
                          Xuất excel
                        </Button>

                      </div>
                    </li>

                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <div
                id="DataTables_Table_1_wrapper"
                className="dataTables_wrapper dt-bootstrap4 no-footer"
              >
                <div className="row justify-between g-2">
                  <div className="col-8 col-sm-6 text-start"></div>
                  <div className="col-5 col-sm-6 text-end">
                    <div className="datatable-filter">
                      <div className="d-flex justify-content-end g-2">
                        <div
                          className="dataTables_length"
                          id="DataTables_Table_1_length"
                        >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="my-3" ref={printRef}>
                  <h5 className="text-center">Kiểm kê dòng tiền tháng {moment(filter.monthYear, 'YYYY-MM').format('MM-YYYY')}</h5>
                  <Table
                    loading={loading}
                    columns={colTable}
                    data={data}
                    notShowPagi={true}
                    headerRow={<tr>
                      <td colSpan={3}>Đầu kì</td>
                      <td>
                        <NumericFormat
                          displayType={"text"}
                          value={summary.firstAmount}
                          thousandsGroupStyle="thousand"
                          thousandSeparator=","
                          decimalScale={2}
                        />
                      </td>
                    </tr>}
                    customRow={() => <tr>
                      <td colSpan={3}>Cuối kì</td>
                      <td>
                        <NumericFormat
                          displayType={"text"}
                          value={summary.lastAmount}
                          thousandsGroupStyle="thousand"
                          thousandSeparator=","
                          decimalScale={2}
                        />
                      </td>
                    </tr>}
                  ></Table>
                </div>
              </div>
            </div>
          </div>
        </Block>
      </Content>
    </React.Fragment>
  );
};

export default MonthlyReport;
